import axios from "axios";
// Public user password reset request
export const requestPublicUserPasswordReset = async (email) => {
  return await API.post('/publicuser/password-reset-request', { email });
};


// Public User Login API
export const loginPublicUser = async (payload) => {
  return await API.post("/publicuser/login", payload);
};

// Administrative Register API
export const registerAdministrative = async (data) => {
  return await API.post("/administrative/register", data);
};

// Administrative Login API
export const loginAdministrative = async (credentials) => {
  return await API.post("/administrative/login", credentials);
};

// HR Register API
export const registerHr = async (data) => {
  return await API.post("/hr/register", data);
};

// HR Login API
export const loginHr = async (credentials) => {
  return await API.post("/hr/login", credentials);
};

// ✅ Login API for Admin (Superadmin and Subadmin)
export const loginAdmin = async (credentials) => {
  return await API.post("/login", credentials);
};

// Update Eligibility Criteria API
export const updateEligibilityCriteria = async (id, data) => await API.patch(`/eligibility/${id}`, data);
// ✅ Get all public users (for admin panel)
export const getPublicUsers = async () => {
  return await API.get("/publicuser");
};

// Publish JobSelection
export const publishJobSelection = async (id) => await API.patch(`/job-selections/${id}/publish`);

// Search Jobs API
export const searchJobs = async (query) => {
  return await API.get("/search", { params: { name: query } });
};


const API_BASE_URL = process.env.REACT_APP_API_URL || "/api";
const API = axios.create({ baseURL: API_BASE_URL });
export { API };

API.interceptors.request.use((config) => {
  const token = localStorage.getItem("token");

  if (token) {
    config.headers = config.headers || {};
    config.headers.Authorization = `Bearer ${token}`;
  }

  return config;
});



export const changeAdminCredentials = async (payload) => {
  return await API.post("/change-credentials", payload);
};

export const verifyAdminToken = async () => {
  return await API.get("/verify");
};

export const exportDateRangeDoc = async (startDate, endDate) => {
  return await API.get("/export/date-range-doc", {
    params: { startDate, endDate },
    responseType: "blob",
  });
};

// ✅ Add HeadTable Item
export const addHeadTableItem = async (data) => {
  return await API.post("/headtable", data);
};

// ✅ Get all HeadTable Items
export const getHeadTableItems = async () => {
  return await API.get("/headtable");
};

// ✅ Get single HeadTable Item by slug
export const getHeadTableBySlug = async (slug) => {
  return await API.get(`/headtable/${slug}`);
};

// ✅ Delete HeadTable Item by ID
export const deleteHeadTableItem = async (id) => {
  return await API.delete(`/headtable/${id}`);
};

// Job APIs
export const addJob = async (data) => await API.post("/job", data);
export const getJobs = async (options = {}) => {
  const params = {};
  if (options?.limit) params.limit = options.limit;
  const config = { params };
  if (options?.signal) config.signal = options.signal;
  if (options?.skipLoader) config.skipLoader = true;
  return await API.get("/job", config);
};
export const updateJobHomeVisibility = async (id, showOnHome) => await API.patch(`/job/${id}/home-visibility`, { showOnHome });
export const deleteJob = async (id) => await API.delete(`/job/${id}`);

// Eligibility Criteria APIs
export const addEligibilityCriteria = async (data) => await API.post("/eligibility", data);
export const getEligibilityCriterias = async (status) => {
  if (status) {
    return await API.get(`/eligibility?status=${status}`);
  }
  return await API.get("/eligibility");
};
export const deleteEligibilityCriteria = async (id) => await API.delete(`/eligibility/${id}`);

// Result APIs
export const addResult = async (data) => await API.post("/result", data);
export const getResults = async (statusOrOptions, maybeOptions = {}) => {
  const status = typeof statusOrOptions === "string" ? statusOrOptions : statusOrOptions?.status;
  const options = typeof statusOrOptions === "string" ? maybeOptions : (statusOrOptions || {});

  const params = {};
  if (status) params.status = status;
  if (options?.limit) params.limit = options.limit;

  const config = { params };
  if (options?.signal) config.signal = options.signal;
  if (options?.skipLoader) config.skipLoader = true;
  return await API.get("/result", config);
};
export const approveResult = async (id) => await API.patch(`/result/${id}/approve`);
export const getResultBySlug = async (slug) => await API.get(`/result/${slug}`);
export const deleteResult = async (id) => await API.delete(`/result/${id}`);

// AdmitCard APIs
export const addAdmitCard = async (data) => await API.post("/admitcard", data);
export const getAdmitCards = async (options = {}) => {
  const params = {};
  if (options?.status) params.status = options.status;
  if (options?.limit) params.limit = options.limit;
  const config = { params };
  if (options?.signal) config.signal = options.signal;
  if (options?.skipLoader) config.skipLoader = true;
  return await API.get("/admitcard", config);
};
export const getAdmitCardBySlug = async (slug) => await API.get(`/admitcard/${slug}`);
export const deleteAdmitCard = async (id) => await API.delete(`/admitcard/${id}`);

// ✅ Syllabus APIs (AdmitCard style)
export const addSyllabus = async (data) => await API.post("/syllabus", data);
export const getSyllabuses = async (statusOrOptions, maybeOptions = {}) => {
  const status = typeof statusOrOptions === "string" ? statusOrOptions : statusOrOptions?.status;
  const options = typeof statusOrOptions === "string" ? maybeOptions : (statusOrOptions || {});

  const params = {};
  if (status) params.status = status;
  if (options?.limit) params.limit = options.limit;

  const config = { params };
  if (options?.signal) config.signal = options.signal;
  if (options?.skipLoader) config.skipLoader = true;
  return await API.get("/syllabus", config);
};
export const approveSyllabus = async (id) => await API.patch(`/syllabus/${id}/approve`);
export const getSyllabusBySlug = async (slug) => await API.get(`/syllabus/${slug}`);
export const deleteSyllabus = async (id) => await API.delete(`/syllabus/${id}`);

// ✅ AnswerKey APIs (AdmitCard style)
export const addAnswerKey = async (data) => await API.post("/answerkey", data);
export const getAnswerKeys = async (statusOrOptions, maybeOptions = {}) => {
  const status = typeof statusOrOptions === "string" ? statusOrOptions : statusOrOptions?.status;
  const options = typeof statusOrOptions === "string" ? maybeOptions : (statusOrOptions || {});

  const params = {};
  if (status) params.status = status;
  if (options?.limit) params.limit = options.limit;

  const config = { params };
  if (options?.signal) config.signal = options.signal;
  if (options?.skipLoader) config.skipLoader = true;
  return await API.get("/answerkey", config);
};
export const approveAnswerKey = async (id) => await API.patch(`/answerkey/${id}/approve`);
export const getAnswerKeyBySlug = async (slug) => await API.get(`/answerkey/${slug}`);
export const deleteAnswerKey = async (id) => await API.delete(`/answerkey/${id}`);

// ✅ Admission APIs (Job style)
export const addAdmission = async (data) => await API.post("/admission", data);
export const getAdmissions = async (statusOrOptions, maybeOptions = {}) => {
  const status = typeof statusOrOptions === "string" ? statusOrOptions : statusOrOptions?.status;
  const options = typeof statusOrOptions === "string" ? maybeOptions : (statusOrOptions || {});

  const params = {};
  if (status) params.status = status;
  if (options?.limit) params.limit = options.limit;

  const config = { params };
  if (options?.signal) config.signal = options.signal;
  if (options?.skipLoader) config.skipLoader = true;
  return await API.get("/admission", config);
};
export const approveAdmission = async (id) => await API.patch(`/admission/${id}/approve`);
export const getAdmissionBySlug = async (slug) => await API.get(`/admission/${slug}`);
export const deleteAdmission = async (id) => await API.delete(`/admission/${id}`);

// Homepage Single Column APIs
export const saveHomepageSingleColumnSection = async (data) => await API.post("/homepage-single-column", data);
export const getHomepageSingleColumnSection = async () => await API.get("/homepage-single-column");

export const saveJobLinksSection = async (data) => await API.post("/job-links-section", data);
export const getJobLinksSection = async () => await API.get("/job-links-section");

// ✅ Add HFHead
export const addHFHeadItem = async (data) => {
  return await API.post("/mfhead", data);
};

// ✅ Get all HFHead items
export const getHFHeadItems = async () => {
  return await API.get("/mfhead");
};

// ✅ Get single HFHead item by slug
export const getHFHeadBySlug = async (slug) => {
  return await API.get(`/mfhead/${slug}`);
};

// ✅ Delete HFHead item by ID
export const deleteHFHeadItem = async (id) => {
  return await API.delete(`/mfhead/${id}`);
};

// ✅ Add MFRecruitment
export const addMFRecruitmentItem = async (data) => {
  return await API.post("/mfrecruitment", data);
};

// ✅ Get all MFRecruitments
export const getMFRecruitments = async () => {
  return await API.get("/mfrecruitment");
};

// ✅ Get single MFRecruitment by slug
export const getMFRecruitmentBySlug = async (slug) => {
  return await API.get(`/mfrecruitment/${slug}`);
};

// ✅ Delete MFRecruitment item by ID
export const deleteMFRecruitmentItem = async (id) => {
  return await API.delete(`/mfrecruitment/${id}`);
};

// Contact APIs
export const saveContact = (data) => API.post("/contact", data); 
export const getContacts = () => API.get("/contact");
export const deleteContact = (id) => API.delete(`/contact/${id}`);


export const fetchFooterLinks = () => API.get("/footer");
export const addOrUpdateFooter = (data) => API.post("/footer", data);

// JobSelection APIs
export const saveJobSelection = async (data) => await API.post("/job-selections", data);
export const getJobSelections = async () => await API.get("/job-selections");
export const getJobSelectionBySlug = async (slug) => await API.get(`/job-selections/${slug}`);
export const deleteJobSelection = async (id) => await API.delete(`/job-selections/${id}`);



// Feedback APIs
export const getFeedbacks = async () => await API.get("/feedback");
export const deleteFeedback = async (id) => await API.delete(`/feedback/${id}`);

// ...existing code...

export default API;
